import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HeroSectionProps {
  children: ReactNode;
  className?: string;
  padding?: "compact" | "comfortable";
  showGrid?: boolean;
  showGlows?: boolean;
}

export function HeroSection({
  children,
  className,
  padding = "comfortable",
  showGrid = true,
  showGlows = true,
}: HeroSectionProps) {
  const paddingClass =
    padding === "compact"
      ? "px-8 pt-5 pb-6"
      : "px-8 pt-8 pb-9";

  return (
    <section
      className={cn(
        "relative overflow-hidden text-white bg-[#08254c] border-b border-white/[0.06]",
        paddingClass,
        className,
      )}
    >
      {showGrid && <div className="mg-hero-grid" aria-hidden="true" />}
      {showGlows && (
        <>
          <div className="mg-hero-glow-a" aria-hidden="true" />
          <div className="mg-hero-glow-b" aria-hidden="true" />
        </>
      )}
      <div className="relative z-[2]">{children}</div>
    </section>
  );
}
